import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ConfigProvider, Pagination, Table } from "antd";
import moment from "moment";

import orderApi from "../../../apis/Order.api";
import queryLogApi from "../../../apis/QueryLog.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ApiService from "../../../utils/ApiService";
import ReportStatisticsComponent from "../ReportStatisticsComponent";

import SettlementDropdown from "./SettlementDropdown";

const api = new ApiService();
const SettlementCase = ({
	targetYear,
	setTargetYear,
	targetMonth,
	setTargetMonth,
	orderTotalList,
	orderLoading,
}) => {
	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));
	const user = useSelector((state) => state.auth.user);

	const columns = [
		// {
		// 	title: "주문번호",
		// 	dataIndex: "order_id",
		// 	key: "order_id",
		// 	width: 80,
		// 	align: "center",
		// },
		// {
		// 	title: "상품주문번호",
		// 	dataIndex: "order_detail_id",
		// 	key: "order_detail_id",
		// 	align: "center",
		// 	width: 100,
		// },
		{
			title: "브랜드명",
			dataIndex: "product_brand_name",
			key: "product_brand_name",
			width: 100,
			// sorter: (a, b) => {
			// },
		},
		{
			title: "상품명",
			dataIndex: "product_name",
			key: "product_name",
			align: "center",
			ellipsis: true,
			width: 170,
			render: (value, record) => {
				if (value && record) {
					return value;
				}
			},
		},
		{
			title: "옵션명",
			width: 180,
			dataIndex: "option_title",
			key: "option_title",
			render: (value, record) => {
				if (record.option_id) {
					return value;
				}
			},
		},
		// {
		// 	title: "구매자명",
		// 	dataIndex: "name",
		// 	key: "name",
		// 	align: "center",
		// 	width: 80,
		// 	render: (value) => {
		// 		if (value) {
		// 			if (value?.length < 3) {
		// 				return value?.slice(0, 1) + "*";
		// 			} else {
		// 				return value?.slice(0, 1) + "*" + value?.charAt(value.length - 1);
		// 			}
		// 		} else {
		// 			return null;
		// 		}
		// 	},
		// },
		// {
		//     title: '정산 금액',
		//     dataIndex: '',
		//     key: '',
		//     align: "center",
		//     render: (value) => {
		//         if (value) {
		//             let vat = value?.vat;
		//             let profit = (value.total_price * (value.commission_rate / 100));
		//             let tax = vat ? Math.round(profit * 0.1) : Math.round(profit * 0.033);
		//             let calculate = vat ? profit + tax : profit - tax;
		//             return (
		//                 <span className={`blue`}>
		//                     {calculate.toLocaleString()}
		//                 </span>
		//             )
		//         }
		//     }
		// },
		{
			title: "수익 금액",
			dataIndex: "",
			key: "",
			align: "center",
			render: (value) => {
				if (value) {
					return (
						<span className={`blue`}>
							{Math.round(
								value.total_price * (value.commission_rate / 100)
							).toLocaleString()}
						</span>
					);
				}
			},
		},
		{
			title: "판매 금액",
			dataIndex: "total_price",
			key: "total_price",
			align: "center",
			render: (value, record) => {
				if (value) {
					return <span>{value.toLocaleString()}</span>;
				}
			},
		},
		{
			title: "수익율",
			dataIndex: "commission_rate",
			key: "commission_rate",
			align: "center",
			render: (value, record) => {
				return <span>{value.toLocaleString()}%</span>;
			},
		},
		// {
		//     title: `${orderList[0]?.vat ? "부가가치세" : "원천세"}`,
		//     dataIndex: '',
		//     key: '',
		//     align: "center",
		//     render: (value, record) => {
		//         let vat = value?.vat;
		//         let profit = (value.total_price * (value.commission_rate / 100));
		//         let tax = vat ? Math.round(profit * 0.1) : Math.round(profit * 0.033);
		//         if (value) {
		//             if (vat) {
		//                 return (
		//                     <p className={`red`}>
		//                         {tax.toLocaleString()}
		//                     </p>
		//                 )
		//             } else {
		//                 return (
		//                     <p className={`red`}>
		//                         -{tax.toLocaleString()}
		//                     </p>
		//                 )
		//             }
		//         }
		//     }
		// },
		{
			// title: '결제일',
			title: "구매확정일",
			dataIndex: "complete_date",
			key: "complete_date",
			align: "center",
			width: 150,
			render: (value) => {
				if (value) {
					return <span>{moment(value).format("YYYY.MM.DD HH:mm")}</span>;
				}
			},
		},
		{
			// title: '결제일',
			title: "구매일",
			dataIndex: "created_at",
			key: "created_at",
			align: "center",
			width: 150,
			render: (value) => {
				if (value) {
					return <span>{moment(value).format("YYYY.MM.DD HH:mm")}</span>;
				}
			},
		},
	];

	const renderEmpty = () => (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			}}
		>
			<img
				src={`/assets/images/report/empty-data.png`}
				alt={`채널 이미지`}
				style={{ height: 70, width: 70 }}
			/>
			<span style={{ color: "rgba(0, 0, 0, 0.25)" }}>
				리포트가 비었습니다 지금부터 당영투게더와 함께하세요!
			</span>
		</div>
	);

	const [orderList, setOrderList] = useState([]);
	const [statistics, setStatistics] = useState({});

	const pageSize = 10;
	const [currentPageNumber, setCurrentPageNumber] = useState(1);
	const [totalSize, setTotalSize] = useState(0);
	// const [offset, setOffset] = useState(0);

	useEffect(() => {
		getStatisticsStatus();
	}, [targetYear, targetMonth]);

	useEffect(() => {
		setTotalSize(orderTotalList.length);
		// setOffset(0);
		setCurrentPageNumber(1);
		setOrderList(orderTotalList.slice(0, 10));
	}, [orderTotalList]);

	/**
	 * 건별 로직 가져오기
	 * @returns {Promise<void>}
	 */
	const getStatisticsStatus = async () => {
		setIsLoading(true);
		const linkParam = {
			userId: user?.id,
		};
		const linkRes = await api.getProductLinkList(linkParam);
		if (
			linkRes.data.code === 200 &&
			linkRes.data.result &&
			linkRes.data.result.length > 0
		) {
			const linkList = linkRes.data.result.map((link) => link.query);
			const query = linkList.join(",");
			const queryLogParam = {
				startDate: moment(`${targetYear}-${targetMonth}`)
					.startOf("month")
					.format("YYYYMMDDHHmm"),
				endDate: moment(`${targetYear}-${targetMonth}`)
					.endOf("month")
					.format("YYYYMMDDHHmm"),
				query: query,
			};
			const param = {
				startDate: moment(`${targetYear}-${targetMonth}`)
					.startOf("month")
					.format("YYYYMMDDHHmm"),
				endDate: moment(`${targetYear}-${targetMonth}`)
					.endOf("month")
					.format("YYYYMMDDHHmm"),
				queryList: query,
				influencerId: user?.id,
			};
			const queryLogRes = await queryLogApi.queryLogByInfluencer(queryLogParam);
			const res = await orderApi.orderStatistics(param);
			if (queryLogRes.code === 200 && res.code === 200) {
				setStatistics({
					click: queryLogRes.result,
					purchases_num: res.result.purchases_num ?? 0,
					purchases_complete_num: res.result.purchases_complete_num ?? 0,
					cvr:
						queryLogRes.result &&
						queryLogRes.result !== 0 &&
						res.result.purchases_complete_num
							? (
									(res.result.purchases_complete_num / queryLogRes.result) *
									100
							  ).toFixed(2)
							: 0.0,
					combined_amount: res.result.combined_amount ?? 0,
					expected_profit_amount: res.result.expected_profit_amount ?? 0,
					profit_amount: res.result.profit_amount ?? 0,
					total_price: res.result.total_purchase_amount ?? 0,
					kakao_push_amount: res.result?.kakao_push_amount ?? 0,
				});
			}
		}
		setIsLoading(false);
	};

	/**
	 * page 넘김
	 */
	const handleChangePagination = (pageNumber) => {
		const currOffset = (pageNumber - 1) * pageSize;
		setCurrentPageNumber(pageNumber);
		// setOffset(currOffset);
		setOrderList(orderTotalList.slice(currOffset, currOffset + 10));
	};
	return (
		<>
			<SettlementDropdown
				targetYear={targetYear}
				setTargetYear={setTargetYear}
				targetMonth={targetMonth}
				setTargetMonth={setTargetMonth}
			/>

			<ReportStatisticsComponent
				statistics={statistics}
				orderList={orderList}
				type={"case"}
				targetMonth={targetMonth}
			/>
			<ConfigProvider renderEmpty={renderEmpty}>
				<Table
					className="report-table-wrap"
					style={{ marginTop: "1em" }}
					columns={columns}
					// dataSource={settlementList}
					dataSource={orderList}
					loading={isLoading || orderLoading}
					rowKey="order_detail_id"
					size="small"
					footer={() => <></>}
					// onChange={handelTableChange}
					showSorterTooltip={false}
					pagination={false}
				/>
			</ConfigProvider>
			<Pagination
				className="report-pagination-wrap"
				showSizeChanger={false}
				current={currentPageNumber}
				pageSize={pageSize}
				total={totalSize}
				onChange={handleChangePagination}
			/>
		</>
	);
};
export default SettlementCase;
